import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/service-dishes', { params }),
  putImage: (id, file) => {
    const formData = new FormData()
    formData.append('file', file)

    return axios.put(`/api/admin/v1/service-dishes/${id}/image`, formData)
  },
  sync: () => axios.post('/api/admin/v1/service-dishes/sync'),
}
